export class Subdomain {

    static getSubdomain() {
        let hostNameIndex = window.location.host.indexOf(process.env.VUE_APP_HOST_NAME);
        return hostNameIndex ? window.location.host.substr(0, hostNameIndex - 1) : null;
    }

}
